import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { fetchData } from '../../helpers/methods';
import { CustomerContext } from '../../contexts/customer-context';
import { CustomerBrandingContext } from '../../contexts/customer-branding-context';

import Button from '../../component-library/button';
import ButtonIcon from '../../component-library/button-icon';
import Tile from '../../component-library/tile';
import Icon from '../../component-library/icon';
import SpinnerContainer from '../../component-library/spinner-container';
import SearchCard from '../../component-library/search-card';

const Landing = () => {
	const navigate = useNavigate();
	const {
		search: {
			taxonomies: customerTaxonomyData,
		} = {},
		portalUIConfig: {
			mainNavigation: mainNavUiConfig = {},
		} = {},
	} = useContext(CustomerContext);
	const {
		landingTitle,
		landingMessage,
	} = useContext(CustomerBrandingContext);
	const [loadingRecent, setLoadingRecent] = useState(true);
	const [recentData, setRecentData] = useState([]);
	const [topLinks, setTopLinks] = useState([]);
	const [announcementsData, setAnnouncementsData] = useState([]);

	const getData = () => {
		setLoadingRecent(true);
		fetchData({
			uri: '/api/web/my/store',
			method: 'GET',
		})
			.then(res => {
				const newData = res.body.recentSummary;
				setRecentData(newData);
				setLoadingRecent(false);
			})
			.catch(() => {
				setLoadingRecent(false);
			});
	};

	const getAnnouncementsData = () => {
		fetchData({
			uri: '/api/web/my/store',
			method: 'GET',
		})
			.then(res => {
				const newAnnouncementsData = res.body.announcements;
				setAnnouncementsData(newAnnouncementsData);
			});
	};

	const getTopLinks = () => {
		const newTopLinks = [
			{
				icon: 'heart',
				label: 'My Favorite APIs',
				description: 'See all of your favorite APIs',
				buttonLabel: 'View Favorite APIs',
				buttonUrl: '/catalog/favorites',
			},
			{
				icon: 'newspaper',
				label: 'Latest News',
				description: 'See all of the latest news',
				buttonLabel: 'View Latest News',
				buttonUrl: '/news/announcements',
			},
		];
		if (mainNavUiConfig?.topApis?.enabled !== false) {
			newTopLinks.splice(0, 0, {
				icon: 'ranking-star',
				label: 'Top APIs',
				description: 'See our highest ranking APIs',
				buttonLabel: 'View Top APIs',
				buttonUrl: '/catalog/top-apis',
			});
		}
		if (mainNavUiConfig?.taxonomy?.enabled !== false && customerTaxonomyData?.length > 0) {
			newTopLinks.push(
				{
					icon: 'sitemap',
					label: 'Taxonomy',
					description: 'Browse the taxonomy to find APIs',
					buttonLabel: 'View Taxonomy',
					buttonUrl: '/catalog/taxonomy',
				},
			);
		}
		setTopLinks(newTopLinks);
		getAnnouncementsData();
	};

	const handleCardClick = id => {
		navigate(`catalog/details/${id}`);
	};

	useEffect(() => {
		getTopLinks();
		getData();
	}, []);

	return (
		<>
			<div className="border-bottom padding-top-40 padding-bottom-24 margin-bottom-24">
				<h1 className="landing_title">{landingTitle}</h1>
				<p className="large-text margin-bottom-32">{landingMessage}</p>
				<Button
					type="primary"
					label="Discover our APIs"
					onClick={() => navigate('/catalog')}
				/>
			</div>
			<div className="full-width__results-grid border-bottom padding-bottom-24 margin-bottom-24">
				{topLinks.length ? (
					topLinks.map((link, index) => (
						// eslint-disable-next-line react/no-array-index-key
						<Tile key={index}>
							{link.label === 'Latest News' && announcementsData?.length > 0 && (
								<div className="tile__badge" />
							)}
							<Icon icon={link.icon} classes="margin-bottom-8" />
							<h5>{link.label}</h5>
							<p className="margin-bottom-16">{link.description}</p>
							<ButtonIcon
								icon="chevron-right"
								label={link.buttonLabel}
								isSmall
								iconRight
								onClick={() => navigate(link.buttonUrl)}
							/>
						</Tile>
					))
				) : null}
			</div>
			<h3>Recently Viewed</h3>
			{loadingRecent && (
				<SpinnerContainer />
			)}
			{!loadingRecent && (
				recentData?.length > 0 ? (
					<div className="full-width__results-grid margin-bottom-24">
						{recentData.slice(0, 4).map((item, index) => (
							<SearchCard
								// eslint-disable-next-line react/no-array-index-key
								key={index}
								id={item.id}
								title={item.name}
								interfaceType={item.interfaceType?.name}
								version={item.version}
								description={item.description}
								state={item.state}
								division={item.division}
								favourite={item.userFavourite}
								subscribed={item.userWatched}
								objectType={item.objectType}
								handleCardClick={id => handleCardClick(id)}
							/>
						))}
					</div>
				) : (
					<p className="grey-text">You have no recently viewed APIs</p>
				))}
		</>
	);
};

export default Landing;
